var ReactRailsUJS = require("react_ujs")
var myCustomContext = require.context("react/lab/src", true)
ReactRailsUJS.useContext(myCustomContext)

